import React from 'react';
import { useIntl } from 'react-intl-next';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { toggleBulletList as toggleBulletListKeymap, formatShortcut } from '@atlaskit/editor-common/keymaps';
import { listMessages } from '@atlaskit/editor-common/messages';
import { getInputMethodFromParentKeys } from '@atlaskit/editor-common/toolbar';
import { ListBulletedIcon, ToolbarDropdownItem, ToolbarKeyboardShortcutHint } from '@atlaskit/editor-toolbar';
export var BulletedListMenuItem = function BulletedListMenuItem(_ref) {
  var api = _ref.api,
    parents = _ref.parents;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['list'], function (states) {
      var _states$listState, _states$listState2;
      return {
        bulletListActive: (_states$listState = states.listState) === null || _states$listState === void 0 ? void 0 : _states$listState.bulletListActive,
        bulletListDisabled: (_states$listState2 = states.listState) === null || _states$listState2 === void 0 ? void 0 : _states$listState2.bulletListDisabled
      };
    }),
    bulletListActive = _useSharedPluginState.bulletListActive,
    bulletListDisabled = _useSharedPluginState.bulletListDisabled;
  var onClick = function onClick() {
    api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 ? void 0 : api.list.commands.toggleBulletList(getInputMethodFromParentKeys(parents)));
  };
  var shortcut = formatShortcut(toggleBulletListKeymap);
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    elemBefore: /*#__PURE__*/React.createElement(ListBulletedIcon, {
      label: ""
    }),
    elemAfter: shortcut ? /*#__PURE__*/React.createElement(ToolbarKeyboardShortcutHint, {
      shortcut: shortcut
    }) : undefined,
    isSelected: bulletListActive,
    isDisabled: bulletListDisabled,
    onClick: onClick,
    ariaKeyshortcuts: shortcut
  }, formatMessage(listMessages.bulletedList));
};